import React from "react";
import OrderedModuleEditor from "@/components/common/OrderedModuleEditor";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

const Field = ({ label, children }) => (
  <div className="space-y-1">
    <Label className="text-xs text-white/50">{label}</Label>
    {children}
  </div>
);

export default function ProcessSteps() {
  return (
    <OrderedModuleEditor
      resource="admin/site/process"
      singular="step"
      title="Process Steps"
      subtitle="Drag to reorder the working process shown to clients."
      titleKey="title"
      defaultValues={{ order: 1, step: "", title: "", description: "", status: "published" }}
      enableStatus
      getItemLabel={(it, idx) => it.title || `Step ${idx + 1}`}
      renderPreviewItem={(it, idx) => (
        <div className="flex gap-3 items-start">
          <span className="text-lg font-mono text-white/40 shrink-0">{it.step || String(idx + 1).padStart(2, "0")}</span>
          <div>
            <div className="text-sm font-medium text-white">{it.title || "Untitled step"}</div>
            {it.description && <p className="text-xs text-white/50 mt-1 line-clamp-2">{it.description}</p>}
          </div>
        </div>
      )}
      renderInspector={(item, patch) => (
        <>
          <Field label="Step Number">
            <Input value={item.step || ""} onChange={(e) => patch({ step: e.target.value })} placeholder="01" className="bg-black/20 border-white/10 text-white" />
          </Field>
          <Field label="Title">
            <Input value={item.title || ""} onChange={(e) => patch({ title: e.target.value })} className="bg-black/20 border-white/10 text-white" />
          </Field>
          <Field label="Description">
            <Textarea value={item.description || ""} onChange={(e) => patch({ description: e.target.value })} rows={4} className="bg-black/20 border-white/10 text-white" />
          </Field>
        </>
      )}
    />
  );
}
